import script from "./VideoCaptionListSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoCaptionListSection.vue?vue&type=script&lang=ts&setup=true"

import "./VideoCaptionListSection.vue?vue&type=style&index=0&id=9340f608&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9340f608"]])

export default __exports__